import { ChangeEvent, FunctionComponent, useEffect, useState } from "react";
import "./custom-dropdown.css";
import { Dropdown } from "react-bootstrap";
import { DropdownPropsInterface } from "../../utils/constants/Interfaces.constants";
import transformString from "../../utils/helpers/transformString";
import useInputValidation from "../../hooks/useInputValidation";

const CustomDropdown: FunctionComponent<DropdownPropsInterface> = ({
  currentValue = { id: 0, name: "" },
  menuItems,
  onClick,
  label = "",
  menuItemKey,
  type,
  required = true,
  searchable = false,
  searchMasterData = [],
  searchSetData,
  disabled = false,
  focus = false,
}) => {
  const { bindValue, modifyFieldTouched } = useInputValidation();

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (searchable && currentValue.name.length !== 0) {
      setSearchText(currentValue.name);
    }

    if (searchable && currentValue.name.length === 0) {
      setSearchText("");
    }
  }, [currentValue]);

  const onSearch = (ev: ChangeEvent<HTMLInputElement>) => {
    setSearchText(ev.target.value);

    if (ev.target.value.length === 0) {
      searchSetData([]);
      onClick({ target: { type: type } }, { id: 0, name: "" });
      return;
    }

    let filtered = searchMasterData.filter((data) =>
      data[menuItemKey].toLowerCase().includes(ev.target.value.toLowerCase())
    );

    searchSetData(filtered);
  };

  return (
    <div className="mf-admin-dropdown-container  d-flex flex-column">
      <Dropdown className="mf-admin-dropdown" {...bindValue(type)}>
        {searchable === false && (
          <Dropdown.Toggle
            onBlur={() => modifyFieldTouched(type, true)}
            disabled={disabled}
            name={type}
            className="mf-admin-dropdown-toggle w-100 text-start"
          >
            {currentValue.name?.length === 0
              ? "Please select..."
              : currentValue.name}
          </Dropdown.Toggle>
        )}

        {searchable && (
          <Dropdown.Toggle
            disabled={disabled}
            {...bindValue(type)}
            name={type}
            className="mf-admin-dropdown-toggle w-100 text-start"
          >
            <input
              type="text"
              className="w-100 no-border dropdown-search font-13 text-primary-color"
              placeholder="Search technical person..."
              onChange={onSearch}
              value={searchText}
              onFocus={() => modifyFieldTouched(type, true)}
            />
          </Dropdown.Toggle>
        )}

        <Dropdown.Menu className="mf-admin-dropdown-menu w-100 custom-scrollbar">
          {menuItems.length !== 0 ? (
            menuItems.map((item, index) => (
              <Dropdown.Item
                key={index}
                type={type}
                data-selected={
                  transformString(currentValue.name, " ", "") ===
                  transformString(item[menuItemKey], " ", "")
                }
                className="mf-admin-dropdown-menu-item"
                onClick={(ev) => onClick(ev, item)}
              >
                {item[menuItemKey]}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item className="mf-admin-dropdown-menu-item">
              No options available...
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
      {required && currentValue.name?.length === 0 && (
        <p className="mb-0 error-msg weight-500">field is required</p>
      )}
      {label.length !== 0 && (
        <label
          className="text-primary-color weight-400 text-capitalize mf-admin-inputfield-label mb-1"
          htmlFor={"role"}
        >
          {label} {required === true && <span className="text-danger">*</span>}
        </label>
      )}
    </div>
  );
};

export default CustomDropdown;
